module.exports = __webpack_public_path__ + "img/LBA-Logo-Text.0548b6be.svg";